import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Circles } from 'react-loader-spinner';
import { FaVideo, FaAngleDoubleRight } from 'react-icons/fa';
import { MdWebStories } from "react-icons/md";
import { HiNewspaper } from "react-icons/hi2";
import { AiFillHome } from "react-icons/ai";
import india from '../india.png';

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }
  return text;
};

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};

export default function MobileHeaders() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark';
  });

  const [newsData, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const ulRef = useRef(null);

  useEffect(() => {
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
    if (darkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [darkMode]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("https://api.shabdtoday.com/api/home/getState");
        setPosts(response.data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (ulRef.current) {
      const contentHeight = ulRef.current.scrollHeight;
      const maxHeight = 400;
      if (contentHeight > maxHeight) {
        ulRef.current.style.setProperty('--scroll-height', `-${contentHeight - maxHeight}px`);
      } else {
        ulRef.current.style.animation = 'none';
      }
    }
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(prevMode => !prevMode);
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Circles height="30" width="30" color="#f7265c" ariaLabel="circles-loading" wrapperStyle={{}} wrapperClass="" visible={true} />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <div className="ak-header-mobile-wrap">
        <div className="ak-container">
          <div className="ak-bar ak-header-mobile-bar ak-mobile-bar ak-bar-dark dark full-width clearfix">
            <div className="container">
              <div className="ak-bar-inner">
                <div className="ak-row ak-row-items-middle">
                  <div className="ak-column ak-column-left ak-column-grow">
                    <div className="ak-inner-row ak-row-items-middle ak-justify-content-left">
                      {/* <div className="ak-bar-item ak-header-menu-handler">
                        <Link to="/" aria-label="Mobile Side Menu" className="ak-menu-handler" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions">
                          <span />
                          <span />
                          <span />
                        </Link>
                      </div> */}
                      <div className="ak-bar-item ak-header-mobile-logo">
                        <div className="ak-logo-wrap ak-logo-image">
                          <Link to="/" rel="home">
                            <img alt="Shabd Today Logo" loading="lazy" className="mobile-logo" width={115} height={48} src="/design/images/logo-s.png" srcSet="/design/images/logo-s.webp 1x, /design/images/logo-s.webp 2x" style={{ padding: '0px' }} />
                          </Link>
                        </div>
                      </div>
                      <div style={{ marginRight: 10 }} className="ak-header-button ak-header-button3">
                        <Link to="/" className="btn small-btn d-flex align-items-center">
                          <AiFillHome size={22} style={{ marginRight: 5 }} />
                        </Link>
                      </div>
                      <div style={{ marginRight: 10 }} className="ak-header-button ak-header-button3">
                        <Link to="/Webstorie-News" className="btn small-btn d-flex align-items-center">
                          <MdWebStories size={22} style={{ marginRight: 5 }} />
                        </Link>
                      </div>
                      <div className="ak-header-button ak-header-button3">
                        <Link to="/Epaper-News" className="btn small-btn d-flex align-items-center">
                          <HiNewspaper size={22} style={{ marginRight: 5 }} />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="ak-column ak-column-right ak-column-normal">
                    <div className="ak-inner-row ak-row-items-middle ak-justify-content-right">
                      <div className="ak-bar-item ak-dark-mode">
                        <div className="ak-toggle-container">
                          <label htmlFor="dark_mode">
                            <span className="screen-reader-text">डार्क मोड</span>
                          </label>
                          <input
                            id="dark_mode"
                            onChange={toggleDarkMode}
                            type="checkbox"
                            className="ak-dark-mode-toggle"
                            checked={darkMode}
                          />
                          <span className="slider round" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="ak-bar ak-header-mobile-bar ak-mobile_menu-bar full-width clearfix">
            <div className="container" style={{ borderBottom: "1px solid grey", padding: "10px" }}>
              <div className="ak-bar-inner">
                <div className="ak-row ak-row-items-middle">
                  <div className="ak-column ak-column-left ak-column-grow">
                    <div className="ak-inner-row ak-row-items-middle ak-justify-content-left">
                      <div className="ak-bar-item ak-mobile-bar-menu-container">
                        <ul
                          ref={ulRef}
                          id="menu-mobile-navigation"
                          className="ak-menu ak-mobile-bar-menu ak-menu-wide ak-menu-style-6 ak-mobile-menu"
                          style={{
                            maxHeight: '400px',
                            overflowY: 'auto',
                            position: 'relative',
                            animation: 'autoScroll 60s linear infinite',
                            animationPlayState: 'running',
                            '--scroll-height': '-1000px', // Fallback
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.animationPlayState = 'paused')}
                          onMouseLeave={(e) => (e.currentTarget.style.animationPlayState = 'running')}
                          onTouchStart={(e) => (e.currentTarget.style.animationPlayState = 'paused')}
                          onTouchEnd={(e) => (e.currentTarget.style.animationPlayState = 'running')}
                          onWheel={(e) => {
                            e.currentTarget.style.animationPlayState = 'paused';
                            setTimeout(() => {
                              e.currentTarget.style.animationPlayState = 'running';
                            }, 2000); // Resume after 2 seconds of inactivity
                          }}
                        >
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-50 menu-item-264">
                            <Link to="/Live-News" style={{ fontWeight: 900, color: '#ff003b', fontFamily: 'emoji' }}>
                              <FaVideo className="live-icon" />
                              <span className="live-text "> LIVE</span>
                            </Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-50 menu-item-264">
                            <Link to="/TajaKhabar-News"><span>🗞️ ताजा खबरें</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-51 menu-item-268">
                            <Link to="/Khel-News"><span>🏏 खेल</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-44 menu-item-261">
                            <Link to="/Technology-News"><span>💻 टेक्नोलॉजी</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-51 menu-item-268">
                            <Link to="/Buisness-News"><span>💼 बिज़नेस</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-51 menu-item-268">
                            <Link to="/World-News"><span>🌍 दुनिया</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-51 menu-item-268">
                            <Link to="/Politics-News"><span>🏛️ पॉलिटिक्स</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-51 menu-item-268">
                            <Link to="/Bollywood-News"><span>🎬 बॉलीवुड</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-51 menu-item-268">
                            <Link to="/Daram-News"><span>🛕 धर्म</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-44 menu-item-261">
                            <Link to="/National-News">
                              <span className="d-flex align-items-center">
                                <img src={india} alt="Logo" style={{ maxWidth: '20px', marginRight: '8px' }} />
                                <span>देश</span>
                              </span>
                            </Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-44 menu-item-261">
                            <Link to="/MadhyaPradesh-News"><span>🌾 मध्यप्रदेश</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-45 menu-item-262">
                            <Link to="/Chhattisgarh-News"><span>🌿 छत्तीसगढ़</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-49 menu-item-266">
                            <Link to="/LifeStyle-News"><span>💖 लाइफस्टाइल</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-48 menu-item-267">
                            <Link to="/Rashifal-News"><span>🔮 राशिफल</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-49 menu-item-258">
                            <Link to="/jansampark"><span>📡 Jansampark RSS</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-49 menu-item-258">
                            <Link to="/Opinions"><span>💬 ओपिनियन</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-51 menu-item-268">
                            <Link to="/Video-News"><span>🎥 वीडियो</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-51 menu-item-268">
                            <Link to="/PrivacyPolicy"><span>Privacy Policy</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-51 menu-item-268">
                            <Link to="/Contactus"><span>Contact Us</span></Link>
                          </li>
                          <li className="menu-item menu-item-type-taxonomy menu-item-object-category menu-term-45 menu-item-254">
                            <Link to="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                              <span>अन्य राज्य</span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div className="offcanvas-header bg-red">
          <h5 className="offcanvas-title text-white" id="offcanvasRightLabel">अन्य राज्य</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
        </div>
        <div className="offcanvas-body bg-red">
          <div className="astronews">
            <div className="block">
              {newsData?.statenames?.length > 0 ? (
                newsData.statenames.map((newsItem) => (
                  <div key={newsItem.stateId} className="itemm" data-bs-dismiss="offcanvas">
                    {/* <Link to={`/OtherState-News/${newsItem.stateESlug}`} className="astro">
                      <div className="title">{newsItem.stateTitle}</div>
                    </Link> */}
                    <Link to={`/${newsItem.stateESlug}`} className="astro">
                      <div className="title">{newsItem.stateTitle}</div>
                    </Link>
                  </div>
                ))
              ) : (
                <div>No data available</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}